import { setCookie, getCookie } from "./cookie";

const $newsletterBar = $(".newsletter-modal");
const showAfter = parseInt($newsletterBar.data("show"));

if (!getCookie("newsletterModal")) {
  setTimeout(function() {
    if ($(window).width() > 767) {
      $newsletterBar.fadeIn();
    }
  }, showAfter);
}

$newsletterBar.find(".close, a").on("click", function() {
  $newsletterBar.fadeOut();
  setCookie("newsletterModal", "true", 999);
});



// WEBPACK FOOTER //
// ../assets/js/newsletter-modal.js